var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgJson = function SvgJson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 4v5.333A1.333 1.333 0 0020 10.667h5.333M18.667 4H9.333a2.667 2.667 0 00-2.666 2.667V16m12-12l6.666 6.667m0 0V16M10 27a1 1 0 001 1h1.667A1.334 1.334 0 0014 26.667v-1.334A1.334 1.334 0 0012.667 24h-1.334A1.334 1.334 0 0110 22.667v-1.334A1.334 1.334 0 0111.333 20H13a1 1 0 011 1m5-1a2 2 0 012 2v4a2 2 0 01-4 0v-4a2 2 0 012-2zm5 8v-8l4 8v-8M3 20h4v6a2 2 0 01-4 0",
    stroke: "#089BEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgJson;